export default function objType(obj: unknown) {
    const type = Object.prototype.toString.call(obj).slice(8, -1);
    if (type === "Object") {
        return "Object";
    }
    return type;
}
